import { render } from "./UiSelect.vue?vue&type=template&id=ce774c8c"
import script from "./UiSelect.vue?vue&type=script&lang=js"
export * from "./UiSelect.vue?vue&type=script&lang=js"

import "./UiSelect.vue?vue&type=style&index=0&id=ce774c8c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__